import React, { useState, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import AppBar from "@material-ui/core/AppBar";

import ShoppingCartIcon from "assets/ShoppingCart.png";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";


/* API */
import { getAuth, onAuthStateChanged } from "firebase/auth";

/* Routing */
import { useHistory } from "react-router-dom";
import { COLORS } from "utils/Constants/Colors";

import logo from "assets/afinazoneTransparente.png";

import Box from "@mui/material/Box";
import BurguerMenu from "components/BurguerMenu/BurguerMenu";
import { isAdmin } from "utils/API/Login";
import AuthPopup from "components/AuthPopup/AuthPopup";
import { Divider } from "@mui/material";
import Banner from "views/Banner/Banner";
import SearchField from "./SearchField";


function SearchBar() {

  /* Funcitons from routing */

  let history = useHistory();

  function handleClickRoute(route) {
    history.push(route);
  }

  const [user, setUser] = useState(null);
  const [admin, setAdmin] = useState(false);

  useEffect(() => {
    const auth = getAuth();
    onAuthStateChanged(auth, async (user) => {
      if (user) {
        // User is signed in, see docs for a list of available properties
        // https://firebase.google.com/docs/reference/js/firebase.User
        setUser(user);
        const roleAdmin = await isAdmin(user);
        setAdmin(roleAdmin);
      }
    });
  }, []);

  return (
    <>
      <AppBar
        position="sticky"
        style={{
          color: "white",
          background: COLORS.back,
          borderStyle: "solid",
          borderBottom: "2px solid white",
          borderWidth: "0px",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Grid
          container
          alignItems="center"
          style={{
            fontWeight: "bold",
            minHeight: "64px", // Altura mínima del AppBar
          }}
        >
          <Grid
            item
            xs={6}
            sm={5}
            style={{ cursor: "pointer" }}
            onClick={() => handleClickRoute("")}
          >
            <Box
              component="img"
              src={logo}
              alt="logo"
              sx={{
                height: { xs: "35px", md: "60px" },
                padding: { xs: "20px", md: "10px" },
              }}
            />
          </Grid>

          <Grid
            item
            xs={12}
            sm={4}
            md={3}
            lg={4}
            sx={{
              display: { xs: "none", md: "flex" },
              alignItems: "center",
              justifyContent: "center",
              px: 2,
            }}
          >
            <Box sx={{ width: "100%", maxWidth: "400px" }}>
              <SearchField />
            </Box>
          </Grid>

          <Grid
            item
            xs={6}
            sm={3}
            md={4}
            lg={3}
            style={{
              padding: "15px",
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end"
            }}
          >
            {user !== null && admin && (
              <AdminPanelSettingsIcon
                fontSize="large"
                sx={{
                  cursor: "pointer",
                  display: { xs: "none", sm: "block" },
                  mr: 1,
                }}
                onClick={() => handleClickRoute("/PanelAdministracion")}
              />
            )}
            <AuthPopup />
            <Divider
              orientation="vertical"
              style={{ background: "white" }}
              sx={{
                marginRight: { xs: "10px", sm: "10px" },
                marginLeft: { xs: "10px", sm: "0px" },
                height: "24px",
              }}
            />
            <div
              fontSize="large"
              style={{ cursor: "pointer" }}
              onClick={() => handleClickRoute("/Carrito")}
            >
              <Box
                component="img"
                src={ShoppingCartIcon}
                alt="shopping_cart"
                sx={{
                  maxHeight: { xs: "23px", sm: "30px" },
                  maxWidth: { xs: "23px", sm: "30px" },
                  paddingTop: { xs: "5px", sm: "8px" },
                  marginRight: { xs: "10px", sm: "10px" },
                  marginLeft: { xs: "10px", sm: "0px" },
                }}
              />
            </div>
            <Divider
              orientation="vertical"
              style={{ background: "white" }}
              sx={{
                display: { xs: "block", sm: "none" },
                marginLeft: { xs: "10px", sm: "10px" },
                height: "24px",
              }}
            />
            <Box
              sx={{
                display: { xs: "block", sm: "none" },
                marginLeft: "10px",
                marginTop: "10px",
                marginRight: { xs: "10px", sm: "10px" },
              }}
            >
              <BurguerMenu />
            </Box>
          </Grid>
        </Grid>
      </AppBar>
      <Box sx={{ display: { xs: "block", sm: "none" } }}>
        <Banner></Banner>
      </Box>
      <Box
        sx={{
          display: { xs: "block", md: "none" },
          padding: "15px",
          width: "80%",
          margin: "0 auto", // Esto lo centra horizontalmente
        }}
      >
      </Box>
    </>
  );
}

export default SearchBar;
